import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
    deleteStoreManualDayEntry,
    StorePosManualDayEntryUpsertPayload,
    StoreManualDayEntryUpsertPayload,
    upsertStorePosManualDayEntry,
    upsertStoreManualDayEntry,
} from 'services/auditService';

export const useUpsertStoreManualDayEntry = (
    storeId: string | null | undefined,
    businessDate: string | null | undefined
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: StoreManualDayEntryUpsertPayload) =>
            upsertStoreManualDayEntry(storeId!, payload),
        onSuccess: async () => {
            toast.success('Manual lottery values saved');
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['store-manual-day-entry', storeId, businessDate] }),
                queryClient.invalidateQueries({ queryKey: ['daily-expanded-report', storeId, businessDate] }),
                queryClient.invalidateQueries({ queryKey: ['store-audit-summaries'] }),
            ]);
        },
    });
};

export const useDeleteStoreManualDayEntry = (
    storeId: string | null | undefined,
    businessDate: string | null | undefined
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => deleteStoreManualDayEntry(storeId!, businessDate!),
        onSuccess: async () => {
            toast.success('Manual lottery values removed');
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['store-manual-day-entry', storeId, businessDate] }),
                queryClient.invalidateQueries({ queryKey: ['daily-expanded-report', storeId, businessDate] }),
                queryClient.invalidateQueries({ queryKey: ['store-audit-summaries'] }),
            ]);
        },
    });
};

export const useUpsertStorePosManualDayEntry = (
    storeId: string | null | undefined,
    businessDate: string | null | undefined
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: StorePosManualDayEntryUpsertPayload) =>
            upsertStorePosManualDayEntry(storeId!, payload),
        onSuccess: async () => {
            toast.success('POS data saved');
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['daily-expanded-report', storeId, businessDate] }),
                queryClient.invalidateQueries({ queryKey: ['store-audit-summaries'] }),
            ]);
        },
    });
};
